<template>
  <div
    class="main-menu menu-fixed menu-accordion menu-shadow"
    :class="[
      { 'expanded': !isVerticalMenuCollapsed || (isVerticalMenuCollapsed && isMouseHovered) },
      skin === 'semi-dark' ? 'menu-dark' : 'menu-light'
    ]"
    @mouseenter="updateMouseHovered(true)"
    @mouseleave="updateMouseHovered(false)"
  >
    <!-- main menu header--> 
    <div class="navbar-header expanded">
      <slot
        name="header"
        :toggleVerticalMenuActive="toggleVerticalMenuActive"
        :toggleCollapsed="toggleCollapsed"
        :collapseTogglerIcon="collapseTogglerIcon"
      >
        <ul class="nav navbar-nav flex-row">

          <!-- Logo & Text -->
          <li class="nav-item mr-auto nav-header">
            <b-link
              class="navbar-brand"
              to="/"
            >
              <span class="brand-only-logo">
                <b-img
                  :src="appLogoImage"
                  alt="logo"
                  loading="lazy"
                  width="150"
                  height="37.5"
                />
              </span>
            </b-link>
          </li>

          <!-- Toggler Button -->
          <li class="nav-item nav-toggle nav-header">
            <b-link class="nav-link modern-nav-toggle">
              <feather-icon
                icon="XIcon"
                size="20"
                class="d-block d-xl-none"
                @click="toggleVerticalMenuActive"
              />
              <span
                class="d-none d-xl-block collapse-toggle-icon"
                @click="() => { toggleCollapsed(); $root.$emit('bv::hide::tooltip', 'menu-collapse-tooltip') }"
                v-b-tooltip.hover.right="{ id: 'menu-collapse-tooltip' }"
                :title="collapseTogglerIconFeather"
                ref="collapseTogglerBtn"
                @mouseleave="$root.$emit('bv::hide::tooltip', 'menu-collapse-tooltip')"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path v-if="!isVerticalMenuCollapsed" d="M12.2855 0.902281C12.4513 0.902281 12.6102 0.968129 12.7275 1.08534L18.9146 7.27252C19.1587 7.5166 19.1587 7.91233 18.9146 8.15641C18.3142 8.7569 17.5747 8.89189 17.0364 8.89189C16.8147 8.89189 16.617 8.86938 16.4605 8.84282L12.5436 12.7597C12.5522 12.7946 12.561 12.8315 12.57 12.8703C12.6373 13.1622 12.713 13.5693 12.7434 14.0258C12.8019 14.904 12.7038 16.135 11.8436 16.9952C11.5995 17.2393 11.2038 17.2393 10.9597 16.9952L7.42416 13.4597L3.44669 17.4372C3.20261 17.6813 1.923 18.5651 1.67892 18.3211C1.43484 18.077 2.31872 16.7974 2.5628 16.5533L6.54028 12.5758L3.00474 9.04029C2.76066 8.79621 2.76066 8.40049 3.00474 8.15641C3.86495 7.2962 5.09603 7.19804 5.97418 7.25658C6.43066 7.28701 6.83776 7.36266 7.12966 7.43002C7.16848 7.43898 7.20539 7.44782 7.24025 7.45643L11.1572 3.53951C11.1306 3.38297 11.1081 3.18532 11.1081 2.96359C11.1081 2.42531 11.2431 1.68583 11.8436 1.08534C11.9608 0.968129 12.1198 0.902281 12.2855 0.902281Z" fill="#10369F"/>
                  <path v-else d="M12.2855 0.902281C12.4513 0.902281 12.6102 0.968129 12.7275 1.08534L18.9146 7.27252C19.1587 7.5166 19.1587 7.91233 18.9146 8.15641C18.3142 8.7569 17.5747 8.89189 17.0364 8.89189C16.8147 8.89189 16.617 8.86938 16.4605 8.84282L12.5436 12.7597C12.5522 12.7946 12.561 12.8315 12.57 12.8703C12.6373 13.1622 12.713 13.5693 12.7434 14.0258C12.8019 14.904 12.7038 16.135 11.8436 16.9952C11.5995 17.2393 11.2038 17.2393 10.9597 16.9952L7.42416 13.4597L3.44668 17.4372C3.20261 17.6813 1.923 18.5651 1.67892 18.3211C1.43484 18.077 2.31872 16.7974 2.5628 16.5533L6.54027 12.5758L3.00474 9.04029C2.76066 8.79621 2.76066 8.40049 3.00474 8.15641C3.86495 7.2962 5.09603 7.19804 5.97418 7.25658C6.43066 7.28701 6.83776 7.36266 7.12966 7.43002C7.16848 7.43898 7.20539 7.44782 7.24025 7.45643L11.1572 3.53951C11.1306 3.38297 11.1081 3.18532 11.1081 2.96359C11.1081 2.42531 11.2431 1.68583 11.8436 1.08534C11.9608 0.968129 12.1198 0.902281 12.2855 0.902281ZM12.4376 3.54269L12.4367 3.5398L12.4376 3.54269ZM12.4367 3.5398L12.4376 3.54269C12.5108 3.76638 12.4521 4.01237 12.2855 4.17893L7.8661 8.59835C7.69885 8.7656 7.45154 8.82409 7.22711 8.74953L7.22459 8.74872L7.20819 8.74353C7.19259 8.73867 7.16788 8.73115 7.13502 8.72171C7.06919 8.70279 6.97119 8.67631 6.84858 8.64801C6.60187 8.59108 6.26319 8.52862 5.89103 8.50381C5.36381 8.46866 4.84642 8.51353 4.4227 8.69049L11.3095 15.5773C11.4865 15.1536 11.5313 14.6362 11.4962 14.109C11.4714 13.7368 11.4089 13.3981 11.352 13.1514C11.3237 13.0288 11.2972 12.9308 11.2783 12.865C11.2688 12.8321 11.2613 12.8074 11.2565 12.7918L11.2513 12.7754L11.2506 12.7735C11.1759 12.549 11.2343 12.3012 11.4016 12.1339L15.8211 7.71447C15.9882 7.54729 16.2354 7.48877 16.4598 7.56319C16.4642 7.56454 16.4733 7.5672 16.4861 7.57069C16.5119 7.57771 16.5531 7.5881 16.6065 7.59879C16.7147 7.62042 16.866 7.64189 17.0364 7.64189C17.1783 7.64189 17.3235 7.6274 17.465 7.5907L12.4093 2.53493C12.3726 2.67646 12.3581 2.82169 12.3581 2.96359C12.3581 3.134 12.3796 3.28528 12.4012 3.39345C12.4119 3.44691 12.4223 3.48812 12.4293 3.51385C12.4328 3.52666 12.4353 3.53538 12.4367 3.5398Z" fill="#10369F"/>
                </svg>
              </span>
            </b-link>
          </li>
        </ul>
      </slot>
    </div>
    <!-- / main menu header-->

    <!-- Shadow -->
    <div
      :class="{'d-block': shallShadowBottom}"
      class="shadow-bottom"
    />

    <!-- main menu content-->
    <vue-perfect-scrollbar
      :settings="perfectScrollbarSettings"
      class="main-menu-content scroll-area"
      tagname="ul"
      @ps-scroll-y="evt => { shallShadowBottom = evt.srcElement.scrollTop > 0 }"
    >
    <!-- :items="navMenuItems" -->
      <vertical-nav-menu-items
        :items="menuItems"
        class="navigation navigation-main"
      />
    </vue-perfect-scrollbar>
    <!-- /main menu content-->
  </div>
</template>

<script>
import { EventBus } from '@/@core/utils/eventBus'
import Vue from 'vue'
import adminMenu from '@/navigation/vertical/new-menu/admin'
import mkpMenu from '@/navigation/vertical/new-menu/mkp'
import companyMenu from '@/navigation/vertical/new-menu/company'
import pudoMenu from '@/navigation/vertical/new-menu/pudo'
import contactMenu from '@/navigation/vertical/new-menu/contact_center'
import customMenu from '@/navigation/vertical/new-menu/custom'
import navMenuItems from '@/navigation/vertical'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { BLink, BImg } from 'bootstrap-vue'
import { provide, computed, ref, watch, getCurrentInstance } from '@vue/composition-api'
import useAppConfig from '@core/app-config/useAppConfig'
import { $themeConfig } from '@themeConfig'
import VerticalNavMenuItems from './components/vertical-nav-menu-items/VerticalNavMenuItems.vue'
import useVerticalNavMenu from './useVerticalNavMenu'
import { mapGetters } from 'vuex'

export default {
  components: {
    VuePerfectScrollbar,
    VerticalNavMenuItems,
    BLink,
    BImg
  },
  props: {
    isVerticalMenuActive: {
      type: Boolean,
      required: true
    },
    toggleVerticalMenuActive: {
      type: Function,
      required: true
    },
    tourActive: {
      type: Boolean
    },
    isShowTooltip: {
      type: Boolean
    }
  },
  computed: {
    ...mapGetters({
      profilesView: 'getProfilesView'
    })
  },
  setup(props, { emit }) {
    const { proxy } = getCurrentInstance()
    let role = Vue.prototype.$session.get('cas_user')?.role
    // Fix solo para walmart
    let profile_type = Vue.prototype.$session.get('cas_user')?.profile_type
    const profiles_walmart = {
      3: 'contact_center'
    } 
    // Nuevos perfiles
    const profile_info = computed(() => proxy.$store.getters.getProfilesView)
    let profile = Vue.prototype.$session.get('cas_user')?.profile

    const {
      isMouseHovered,
      isVerticalMenuCollapsed,
      collapseTogglerIcon,
      toggleCollapsed,
      updateMouseHovered
    } = useVerticalNavMenu(props)
    const { skin } = useAppConfig()    
    // Shadow bottom is UI specific and can be removed by user => It's not in `useVerticalNavMenu`
    const shallShadowBottom = ref(false)
    provide('isMouseHovered', isMouseHovered)
    const perfectScrollbarSettings = {
      maxScrollbarLength: 60,
      wheelPropagation: false
    }
    const collapseTogglerIconFeather = computed(() => (collapseTogglerIcon.value === 'unpinned' ? 'Fijar menú' : 'Desfijar menú'))
    // App Name
    const { appName, appLogoImage } = $themeConfig.app

    const menuOption = {
      admin: adminMenu,
      superadmin: adminMenu,
      marketplace: mkpMenu,
      seller:  companyMenu,
      ecommerce: companyMenu,
      pudo: pudoMenu,
      contact_center: contactMenu,
      custom: customMenu
    }
    const getMenuOptions = () => {
      if (profile && profile_info.value) {
        return profile_info.value?.menu
      }
      // Fix solo para walmart
      const resolvedRoleOrProfileWalmart = profiles_walmart[profile_type] || role
      return menuOption[resolvedRoleOrProfileWalmart] || []
    }
    
    const menuItems = ref(getMenuOptions())
    
    EventBus.$on('reload-menu', (newRole, newProfileType, newProfile) => {
      role = newRole // Actualizar el rol del usuario
      // Fix solo para walmart
      profile_type = newProfileType // Actualizar el tipo de perfil del usuario

      profile = newProfile // Actualizar el nuevo profile del usuario
      
      menuItems.value = getMenuOptions() // Actualizar los elementos del menú
      emit('update-menu-items', getMenuOptions())
    })

    // Emitir el evento cuando `menuItems` cambie
    watch(
      () => menuItems.value,
      (newVal) => {
        emit('update-menu-items', newVal) // Emitir el evento al padre
      },
      { immediate: true } // Ejecutar inmediatamente al montar
    )

    watch(
      () => props.tourActive,
      (newVal, oldVal) => {
        if (newVal) {
          toggleCollapsed() 
        } 
        else if (!newVal && oldVal !== undefined) {
          toggleCollapsed() 
          // Esto se debe a que mas abajo de 1200px se visualiza es un menu hamburguesa
          // para cerrarlo es necesario llamar esta función
          if (window.innerWidth <= 1200 && window.innerWidth >= 768) {
            props.toggleVerticalMenuActive() 
          }
        }
      }, 
      { immediate: true }
    )
    watch(
      () => props.isShowTooltip, // Esto debería ser una propiedad reactiva o computada
      (newVal, oldVal) => {
        if (newVal) {
          toggleCollapsed()
        } else if (!newVal && oldVal !== undefined) {
          toggleCollapsed()
          if (window.innerWidth <= 1200 && window.innerWidth >= 768) {
            props.toggleVerticalMenuActive() 
          }
        }
      },
      { immediate: true }
    )

    return {
      navMenuItems,
      perfectScrollbarSettings,
      isVerticalMenuCollapsed,
      collapseTogglerIcon,
      toggleCollapsed,
      isMouseHovered,
      updateMouseHovered,
      collapseTogglerIconFeather,
      adminMenu,
      mkpMenu,
      companyMenu,
      pudoMenu,
      contactMenu,
      customMenu,
      getMenuOptions,
      menuItems,

      // Shadow Bottom
      shallShadowBottom,

      // Skin
      skin,

      // App Name
      appName,
      appLogoImage
    }
  }
}
</script>

<style lang="scss">
.menu-collapsed.vertical-menu-modern .main-menu:not(.expanded) .navbar-header .navbar-brand .brand-only-logo {
  width: 35px !important;
  overflow: hidden;
}
.main-menu .navbar-header .navbar-brand .brand-only-logo img {
  width: 150px;
  padding-left: 1px;
}
.main-menu .navbar-header {
  margin-bottom: 1rem !important;
}
.navigation.navigation-main a{
  font-size: 13px;
}
@import "~@core/scss/base/core/menu/menu-types/vertical-menu.scss";
#menu-collapse-tooltip {
  margin-left: 0.3rem;
}
#menu-collapse-tooltip .arrow::before {
  border-right-color: #4A5568;
}
#menu-collapse-tooltip .tooltip-inner {
  padding: 0.4rem 1rem;
  background-color: #4A5568;
}
</style>
